import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/">QA Agent</Link>
      </div>

      <div className="navbar-menu">
        {user ? (
          <>
            <Link to="/dashboard" className="nav-link">Dashboard</Link>
            <Link to="/applications" className="nav-link">Applications</Link>
            {user.is_admin && (
              <Link to="/admin" className="nav-link admin-link">Admin</Link>
            )}
            <div className="nav-user">
              <span className="credits-badge">{user.credits} credits</span>
              <span className="username">{user.username}</span>
              <button onClick={handleLogout} className="logout-btn">Logout</button>
            </div>
          </>
        ) : (
          <>
            <Link to="/login" className="nav-link">Login</Link>
            <Link to="/register" className="nav-link register-link">Register</Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
